export default __webpack_public_path__ + "static/media/330_store04-en-web.bc2ee461.png";